'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { WEBVIEW_TYPE_ENTRY } from '@/constants';
import { usePartnerChromeClassName } from '@/hooks/usePartnerChromeClassName';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { resolveWebviewEntry } from '@/utils/resolveWebviewEntry';
import type { filterMainBannerItems } from '../../_utils/filterMainBannerItems';
import { DesktopMainBannerSection } from '../DesktopMainBannerSection';
export const MainBannerSection = t0 => {
  const $ = _c(6);
  const {
    bannerItemsByEntry,
    className
  } = t0;
  const entry = useDeviceInfoStore(_temp);
  const partnerChromeClassName = usePartnerChromeClassName();
  const t1 = bannerItemsByEntry[entry];
  let t2;
  if ($[0] !== className || $[1] !== partnerChromeClassName) {
    t2 = cn(partnerChromeClassName, className);
    $[0] = className;
    $[1] = partnerChromeClassName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <DesktopMainBannerSection bannerItems={t1} className={t2} />;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
function _temp(state) {
  return resolveWebviewEntry(state.subDomain, state.webviewType);
}